import React, { Component } from 'react';
import './css/main.css';

import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import Canvas from './layout/art/Canvas';
import Paragraph from './layout/Paragraph';

class ArtTest extends Component {
    render() {
      return (
          <div>              
              <Navigation/>
              <Canvas/>
              <Paragraph
                titleText="Pretty waves"
                heading="I'm just mocking things around."
                 />
              <Footer/>
          </div>
      );
    }
}

export default ArtTest;



// WEBPACK FOOTER //
// ./src/ArtTest.js